import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, Box } from 'sarsaparilla';

const SiteMapTab = ({ isLoading }) => {
    if (isLoading) {
        return <Spinner isCentered={false} size="xl" />
    }
    return (
        <Box
            padding="md"
            border="gray"
            background="white"
            marginY="md">
            <strong>There are currently no Site Maps available for this Recreation Area.</strong>
        </Box>
    );
}

SiteMapTab.propTypes = {
    isLoading: PropTypes.bool
}

export default SiteMapTab;